import React from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";

const CustomDatePicker = ({
    id,
    name,
    value,
    onChange,
    placeholder = "Select date",
    className = "",
    required = false,
    format = "MMMM DD, YYYY",
    disabled = false,
    ...rest
}) => {
    const handleDateChange = (date) => {
        if (date) {
            const formattedDate = moment(date).format(format);
            onChange(formattedDate);
        } else {
            onChange("");
        }
    };

    const selectedDate = value ? moment(value, format).toDate() : null;

    const convertToDatePickerFormat = (momentFormat) => {
        return momentFormat
            .replace(/MMMM/g, "MMMM")
            .replace(/MMM/g, "MMM")
            .replace(/MM/g, "MM")
            .replace(/DD/g, "dd")
            .replace(/YYYY/g, "yyyy")
            .replace(/YY/g, "yy");
    };

    return (
        <div className="datepicker-wrapper">
            <DatePicker
                id={id}
                name={name}
                selected={selectedDate}
                onChange={handleDateChange}
                placeholderText={placeholder}
                className={`datepicker-input ${className}`}
                dateFormat={convertToDatePickerFormat(format)}
                minDate={new Date()}
                disabled={disabled}
                autoComplete="off"
                showPopperArrow={false}
                onKeyDown={(e) => e.preventDefault()}
                {...rest}
            />
        </div>
    );
};

export default CustomDatePicker;
